export default {
  auth: () => import("/opt/web_client/layouts/Auth.vue").then(m => m.default || m),
  default: () => import("/opt/web_client/layouts/default.vue").then(m => m.default || m)
}